import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import './Login.css';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import apiClient from '../../api';
import { useUser } from '../../context/UserContext';
import { useNotification } from '../../context/NotificationContext';

const LoginPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const notification = useNotification();
  const { user, isAuthenticated, login } = useUser();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  useEffect(() => {
    // If user is already authenticated, redirect them
    if (isAuthenticated) {
      notification.success({
        message: 'Already Logged In',
        placement: 'topRight',
      });
      navigate('/files', { replace: true }); // Use replace to prevent going back to login
    }
  }, [isAuthenticated]);

  // Handle input changes and set state
  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const onFinish = async values => {
    try {
      await form.validateFields();
      const result = await apiClient.post('/login', formData);
      if (result.status / 100 == 2) {
        const { access_token, username, name, email } = result.data;
        const userData = { username, name, email };

        login(access_token, userData);
      } else {
        notification.error({
          message: `Login failed`,
          description: `${result.data['error']}`,
        });
      }
    } catch (error) {
      // errors are already shouwn on the screen
      notification.error({
        message: `Login failed`,
        description: `Server Error, Try again later`,
      });
      console.log('Error:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-left">
          <div className="login-illustration">
            <div className="tagline">
              A tagline is a short, memorable phrase that captures the core of a
              brand's identity and purpose
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-form-wrapper">
            <div className="logo-container">
              <img
                src="/golgix-logo-horiz.png"
                alt="GOLGIX Logo"
                className="login-logo"
              />
            </div>

            <div className="login-header">Sign In Here</div>

            <Form form={form} className="login-form">
              <Form.Item
                name="username"
                className="login-form-item"
                rules={[
                  { required: true, message: 'Please input your username!' },
                ]}
                label="Username"
              >
                <Input
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={e => handleInputChange('username', e.target.value)}
                  className="login-input"
                />
              </Form.Item>

              <Form.Item
                name="password"
                className="login-form-item"
                rules={[
                  { required: true, message: 'Please input your password!' },
                ]}
                label="Password"
              >
                <Input.Password
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={e => handleInputChange('password', e.target.value)}
                  className="login-input"
                  iconRender={visible =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-button"
                  onClick={onFinish}
                >
                  Sign In
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
